export const HomeKitTypes = {
  AccessoryInformation: 'Accessory Information',
  AirQualitySensor: 'Air Quality Sensor',
  BatteryService: 'Battery Service',
  BridgeConfiguration: 'Bridge Configuration',
  BridgingState: 'Bridging State',
  CameraControl: 'Camera Control',
  CameraRTPStreamManagement: 'Camera RTP Stream Management',
  CarbonDioxideSensor: 'Carbon Dioxide Sensor',
  CarbonMonoxideSensor: 'Carbon Monoxide Sensor',
  ContactSensor: 'Contact Sensor',
  Door: 'Door',
  Doorbell: 'Doorbell',
  Fan: 'Fan',
  GarageDoorOpener: 'Garage Door Opener',
  HumiditySensor: 'Humidity Sensor',
  LeakSensor: 'Leak Sensor',
  LightSensor: 'Light Sensor',
  Lightbulb: 'Lightbulb',
  LockManagement: 'Lock Management',
  LockMechanism: 'Lock Mechanism',
  Microphone: 'Microphone',
  MotionSensor: 'Motion Sensor',
  OccupancySensor: 'Occupancy Sensor',
  Outlet: 'Outlet',
  Pairing: 'Pairing',
  ProtocolInformation: 'Protocol Information',
  Relay: 'Relay',
  SecuritySystem: 'Security System',
  SmokeSensor: 'Smoke Sensor',
  Speaker: 'Speaker',
  StatefulProgrammableSwitch: 'Stateful Programmable Switch',
  StatelessProgrammableSwitch: 'Stateless Programmable Switch',
  Switch: 'Switch',
  TemperatureSensor: 'Temperature Sensor',
  Thermostat: 'Thermostat',
  TimeInformation: 'Time Information',
  TunneledBTLEAccessoryService: 'Tunneled BTLE Accessory Service',
  Window: 'Window',
  WindowCovering: 'Window Covering'
} as const

export type HomeKitTypes = typeof HomeKitTypes[keyof typeof HomeKitTypes]
